import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { Button } from "./ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetClose } from "./ui/sheet";
import { AtlasLogo } from "./AtlasLogo";

const navItems = [
  { to: "/check", label: "Check Eligibility" },
  { to: "/match", label: "Find Your Fit" },
  { to: "/tax", label: "Tax Explorer" },
  { to: "/about", label: "Methodology" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header
      data-testid="global-header"
      className={`sticky top-0 z-50 bg-[hsl(var(--background))]/85 backdrop-blur supports-[backdrop-filter]:bg-[hsl(var(--background))]/70 border-b transition-shadow ${scrolled ? "shadow-[0_4px_20px_rgba(15,39,64,0.06)]" : ""}`}
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <AtlasLogo />
        <nav className="hidden md:flex items-center gap-8" data-testid="global-nav">
          {navItems.map((n) => (
            <NavLink key={n.to} to={n.to}
              className={({ isActive }) => `nav-link text-sm font-medium text-[hsl(var(--atlas-slate))] hover:text-[hsl(var(--atlas-navy))] ${isActive ? "active text-[hsl(var(--atlas-navy))]" : ""}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block">
          <Button data-testid="header-check-eligibility-button" onClick={() => navigate("/check")}
            className="bg-[hsl(var(--atlas-navy))] hover:bg-[hsl(var(--atlas-navy-2))] text-white">
            Check your eligibility
          </Button>
        </div>
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid="mobile-nav-sheet-trigger"><Menu className="h-5 w-5" /></Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <div className="mt-8 flex flex-col gap-4">
                {navItems.map((n) => (
                  <SheetClose asChild key={n.to}>
                    <Link to={n.to} className="text-base font-medium text-[hsl(var(--atlas-navy))]">{n.label}</Link>
                  </SheetClose>
                ))}
                <SheetClose asChild>
                  <Button onClick={() => navigate("/check")} className="mt-2 bg-[hsl(var(--atlas-navy))] text-white">Check your eligibility</Button>
                </SheetClose>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
